import { SVGProps, Ref, forwardRef } from 'react';

export const UserFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M1.943 4.513C.347 3.523.371 2.219.637.5c2.104.554 4.078.378 6.152.194C7.866.598 8.97.5 10.131.5c3.442 0 5.37 2.062 5.37 5.5C12.44 3.708 9.848 4.28 7.453 4.81c-1.916.424-3.706.82-5.51-.298"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M.5 8c0-.867.1-1.735.324-2.555q.18.133.381.258c2.324 1.44 4.71.898 6.577.473q.355-.082.684-.152c1.06-.222 2.024-.362 3.008-.251.955.107 2.002.46 3.187 1.347l.836.627q.003.126.003.253c0 3.75-1.875 7.5-7.5 7.5S.5 11.75.5 8m6.675 2.984a.47.47 0 0 1-.143-.32h-1.4c0 .502.209.945.523 1.279.45.48 1.126.754 1.843.754s1.393-.275 1.843-.754c.314-.334.523-.777.523-1.28h-1.4c0 .099-.038.21-.143.321-.158.168-.45.313-.823.313s-.665-.145-.823-.313"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
UserFilledSize16Glyph.displayName = 'UserFilledSize16Glyph';
